import { getVideoTag } from '../ads/adTargeting'
export function getVideoAdsTag() {
  window.getVideoTag = getVideoTag
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/vms/ads/videoAdTag.js